import ApplicationModel, { attr } from '../ApplicationModel';
import { type WhiteboardVersionAttributes } from './generated/WhiteboardVersionAttributes';
import { model } from '../modelBuilder';

interface WhiteboardVersion extends WhiteboardVersionAttributes {}

@model
class WhiteboardVersion extends ApplicationModel {
  // Start auto-generated
  static typename: 'WhiteboardVersion' = 'WhiteboardVersion';
  get typename(): 'WhiteboardVersion' {
    return 'WhiteboardVersion';
  }

  static internalTypename: 'Whiteboard::Version' = 'Whiteboard::Version';
  get internalTypename(): 'Whiteboard::Version' {
    return 'Whiteboard::Version';
  }

  static fields = {
    createdAt: attr({ readable: true }),
    editorContent: attr({ readable: true, json: true }),
    id: attr({ readable: true }),
    updatedAt: attr({ readable: true }),
    version: attr({ readable: true }),
    whiteboard: attr.belongsTo({ readable: true, typename: 'Whiteboard' }),
    authors: attr.hasMany({ readable: true }),
  };
  // End auto-generated
}

export default WhiteboardVersion;
